import {ITimestamp} from "@shared/data-access/interfaces/timestamp.interface";

export interface IDialect extends ITimestamp{
  id:number;
  code:string;
  name:string;
  isActive:boolean;
}
